/*!
 * @monogrid/vue-boost v7.0.0-develop.3 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { getEnv as w } from "@monogrid/env";
import { isObject as A } from "@monogrid/serverless-cms";
import { unref as i, computed as u, isRef as a } from "vue";
const h = {}, f = (t) => {
  if (!t.metaData)
    throw new Error('"metaData" field must be included in the query for the mediaFile');
  return h[t.id] || (h[t.id] = JSON.parse(t.metaData)), h[t.id];
}, d = (t) => f(t)["image-lazy-src"], p = (t) => {
  const e = f(t);
  return parseInt(e["image-width"] || "0");
}, v = (t) => {
  const e = f(t);
  return parseInt(e["image-height"] || "0");
}, D = (t) => p(t) / v(t), s = (t) => A(t) && "id" in t && typeof t.id == "string" && t.id.length > 0, M = (t, e) => {
  const r = w(), c = i(e);
  if (!c)
    return `/media/${t.id}`;
  let I = `${r.OPTIMIZED_IMAGE_API_ENDPOINT}/${t.id}`;
  r.IS_OFFLINE === "true" && (I = `${r.API_ENDPOINT}${r.SERVICE_STAGE}${r.OPTIMIZED_IMAGE_API_ENDPOINT}/${t.id}`);
  const o = {
    ...c,
    q: i(c.q),
    fm: i(c.fm),
    auto: i(c.auto)
  };
  o.auto = o.auto || [], !o.q && !o.auto.includes("compress") && o.auto.push("compress"), !o.fm && !o.auto.includes("format") && o.auto.push("format");
  let $ = "";
  return Object.entries(o).forEach(([g, O], E) => {
    const n = i(O);
    if (n) {
      let l;
      Array.isArray(n) ? n.length > 0 && n[0] !== void 0 && (l = `${E === 0 ? "?" : "&"}${g}=${n.join(",")}`) : n && (l = `${E === 0 ? "?" : "&"}${g}=${n}`), l && ($ += l);
    }
  }), `${I}${$}`;
};
function S({ media: t, optimizedImageParams: e }) {
  return {
    url: u(() => {
      const r = a(t) ? t.value : t;
      return s(r) ? M(r, a(e) ? e.value : e) : void 0;
    }),
    metaData: u(() => {
      const r = a(t) ? t.value : t;
      return s(r) ? f(r) : void 0;
    }),
    aspectRatio: u(() => {
      const r = a(t) ? t.value : t;
      return s(r) ? D(r) : void 0;
    }),
    width: u(() => {
      const r = a(t) ? t.value : t;
      return s(r) ? p(r) : void 0;
    }),
    height: u(() => {
      const r = a(t) ? t.value : t;
      return s(r) ? v(r) : void 0;
    }),
    lazySrc: u(() => {
      const r = a(t) ? t.value : t;
      return s(r) ? d(r) : void 0;
    })
  };
}
const T = {
  isMediaFile: s,
  getMetaData: f,
  getLazySrc: d,
  getWidth: p,
  getHeight: v,
  getAspectRatio: D,
  getOptimizedImageURL: M
};
export {
  T as MediaUtils,
  M as getOptimizedImageURL,
  S as useMedia
};
